export const DEVICES_STATUS = 'devicesStatus'

// List of all registered WS clients
export const wsClientList = {}

// List of WS listeners to reset (only applying on Local Modes)
export const resetDelayListenersFor = []
